import React from "react"
import { Link } from "react-router-dom"
import icon from "./img/moustache.png"

function NavB(props) {
	return (
		<div className="bottom-nav" style={props.styles}>
			<div className="nav-l">
				<img src={icon} alt="" />
				<Link>Career</Link>
				<Link>Articles</Link>
				<Link>Write for us</Link>
			</div>
			<div className="nav-r"></div>
		</div>
	)
}

export default NavB
